import { render } from "./ReportClosedOrders.vue?vue&type=template&id=f8a6b6c8&scoped=true"
import script from "./ReportClosedOrders.vue?vue&type=script&lang=js"
export * from "./ReportClosedOrders.vue?vue&type=script&lang=js"

import "./ReportClosedOrders.vue?vue&type=style&index=0&id=f8a6b6c8&scoped=true&lang=css"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8a6b6c8"]])

export default __exports__